<template>
  <div class="optional-form-item">
    <ElButton
      v-if="!contentVisible"
      class="optional-form-item__add"
      type="text"
      @click="showContent"
    >
      <i class="el-icon-circle-plus-outline optional-form-item__add-icon" />
      {{ addButtonText }}
    </ElButton>

    <ElFormItem v-if="contentVisible" v-bind="$attrs">
      <template slot="label">
        {{ label }}
        <Hint :message="hint" />
      </template>

      <ElButton
        class="optional-form-item__remove"
        type="text"
        icon="el-icon-close"
        @click="hideContent"
      >
        {{ $t('REMOVE') }}
      </ElButton>
      <slot />
    </ElFormItem>
  </div>
</template>

<script>
import Hint from './Hint';

export default {
  name: 'OptionalFormItem',
  components: { Hint },
  props: {
    label: {
      type: String,
      required: true,
    },
    initialVisibility: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    },
    addButtonLabel: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      contentVisible: false,
    };
  },

  computed: {
    addButtonText() {
      if (this.addButtonLabel) return this.addButtonLabel;
      return `${this.$t('ADD')} ${this.label}`;
    },
  },

  watch: {
    initialVisibility: {
      immediate: true,
      handler(value) {
        if (value) {
          this.contentVisible = this.initialVisibility;
        }
      },
    },
  },

  methods: {
    showContent() {
      this.contentVisible = true;
    },
    hideContent() {
      this.contentVisible = false;
      this.$emit('remove');
    },
  },
};
</script>

<style lang="scss">
.optional-form-item {
  margin-bottom: rem-calc(22px);

  &__add {
    padding-top: 0;
    color: $lb-link-color;

    &:hover,
    &:focus {
      color: color.scale($lb-link-color, $lightness: -10%);
    }
  }

  &__add-icon {
    font-size: 1.3rem;
    vertical-align: middle;
  }

  &__remove {
    color: $lb-color-alert;
    position: absolute;
    right: 0;
    top: -$lb-button-height;
    z-index: 1;

    &:hover,
    &:focus {
      color: color.scale($lb-color-alert, $lightness: -10%);
    }

    @include rtl() {
      right: unset;
      left: 0;
    }
  }
}
</style>
